module.exports = __webpack_public_path__ + "img/connectivity-alert-v2.d299d7cc.svg";